module.exports = __webpack_public_path__ + "img/logo.d0cb6b71.png";